import { render, staticRenderFns } from "./OsInputTextField.vue?vue&type=template&id=6470e374&scoped=true"
import script from "./OsInputTextField.vue?vue&type=script&lang=ts"
export * from "./OsInputTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6470e374",
  null
  
)

export default component.exports